export const ENABLE_SCHEMA_ASSISTANT = false
